import React, { useState } from 'react'
import { RiSendPlane2Line } from 'react-icons/ri'
import ShareModal from '@components/ItemPage/Details/Important/Buttons/ShareButton/ShareModal'

const ShareButton = () => {
  const [isOpen, setIsOpen] = useState<boolean>(false)

  return (
    <>
      <ShareModal isOpen={isOpen} setIsOpen={setIsOpen} />
      <button
        onClick={() => setIsOpen(true)}
        className="bg-white text-black hover:text-gray-700 border-black hover:border-gray-700 hover:bg-gray-100 border text-18 rounded py-3 px-4 transition duration-200 font-semibold flex items-center justify-center gap-2"
      >
        <RiSendPlane2Line size={18} />
        Share
      </button>
    </>
  )
}

export default ShareButton
